module.exports = __webpack_public_path__ + "img/clock.0ef930bd.svg";